<template lang="pug">
  .mobile-navigation(
    :class="isMenuOpen ? 'mobile-navigation--is-open' : ''"
  )
    navbar-hamburger(ref="hamburger" @open="openMenu", @close="closeMenu")

    transition(name="fade", @enter="enableLinks()", @leave="disableLinks()")
      .mobile-navigation__nav(v-show="isMenuOpen")
        .mobile-navigation__nav-header
          base-button.button--icon.mobile-navigation__back-button(
            v-if="progressLevel > 1"
            icon="arrow-left"
              icon-size="20px"
              @click="menuRetreat"
              )
          h3.mobile-navigation__menu-heading(v-if="progressLevel > 1 && showLinks") {{ activeMenuTitle }}
          base-button.button--icon.mobile-navigation__close-button(
            icon="close"
            icon-size="20px"
            @click="closeMenu"
          )
        transition-group.mobile-navigation__linklist(tag="ul" :name="menuTransition")
          li.mobile-navigation__node(
            v-for="(menuItem, index) in activeMenuItems"
            v-if="showLinks"
            :key="toKebabCase(menuItem.title)"
          )
            a.mobile-navigation__link(v-if="menuItem.url && menuItem.url !== '#'" :href="menuItem.url") {{ menuItem.title }}
            .mobile-navigation__link(
              v-else="menuItem.children.length"
              @click="menuProgress(menuItem)"
            ) {{ menuItem.title }}
            base-button.button--icon.mobile-navigation__node-icon(
              v-if="!menuItem.url"
              icon="chevron-right"
              icon-size="14px"
              @click="menuProgress(menuItem)"
            )
          .mobile-subnav-tiles-wrapper(
            v-if="progressLevel === 2 && showLinks"
            :key="`subnav_tile`"
          )
            mobile-subnav-tiles(
              :menuItem="activeMenu"
            )
        .mobile-navigation__footer(v-if="progressLevel === 1")
          a.mobile-navigation__account-link(:href="userLink")
            icon(name="circle" size="15px")
            span {{ userLabel }}
          .mobile-navigation__contact-info(
            v-html="contactInfoArea"
          )
</template>

<script>
  import { mapState } from 'vuex';
  import { toKebabCase } from 'scripts/helpers/util';
  import NavbarHamburger from 'scripts/components/site-header/NavbarHamburger.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';
  import Icon from 'scripts/components/basic/Icon.vue';
  import Accordion from 'scripts/components/basic/Accordion.vue';
  import MobileSubnavTiles from 'scripts/components/site-header/MobileSubnavTiles.vue';

  export default {
    name: 'MobileNavigation',
    components: {
      NavbarHamburger,
      BaseButton,
      Icon,
      Accordion,
      MobileSubnavTiles,
    },
    props: {
      menuItems: {
        type: Array,
        default: () => [],
      },
      loggedIn: {
        type: Boolean,
        default: false,
      },
      contactInfoArea: String,
    },
    data() {
      return {
        isMenuOpen: false,
        showLinks: false,
        subnav: null,
        showLogo: true,
        activeMenu: {},
        activeMenuItems: [],
        activeMenuTitles: [],
        previousMenus: [],
        progressLevel: 1,
        menuTransition: 'slide-fade-left',
      };
    },
    computed: {
      ...mapState({
        scrollTop: (state) => state.scroll.scrollTop,
      }),
      userLink() {
        return this.loggedIn ? '/account' : '/account/login';
      },
      userLabel() {
        return this.loggedIn ? 'My Account' : 'Account';
      },
      activeMenuTitle() {
        return this.activeMenuTitles[this.activeMenuTitles.length - 1];
      },
    },
    mounted() {
      this.activeMenuItems = this.menuItems;
    },
    methods: {
      hasSubnav(menuItem) {
        return Object.entries(menuItem).some((value) => {
          if (value[0] === 'name' || value[0] === 'link' || value[0] === 'children') return false;

          if (value[0].includes('image')) {
            return value[1].src;
          }

          return value[1];
        });
      },
      openMenu() {
        this.isMenuOpen = true;
      },
      closeMenu() {
        this.isMenuOpen = false;
        this.$refs.hamburger.isActive = false;
        this.closeSubnav();
      },
      enableLinks() {
        this.showLinks = true;
      },
      disableLinks() {
        this.showLinks = false;
      },
      openSubnav(subnav) {
        this.subnav = subnav;
      },
      closeSubnav() {
        this.subnav = null;
      },
      toKebabCase(stringToAlter) {
        return toKebabCase(stringToAlter);
      },
      menuProgress(menu) {
        this.menuTransition = 'menu-slide-fade-left';

        if (menu.children) {
          this.progressLevel += 1;
          this.previousMenus.push(this.activeMenuItems);
          this.activeMenuTitles.push(menu.title);
          this.activeMenuItems = menu.children;

          if (this.progressLevel === 2) {
            this.activeMenu = menu;
          }
        }
      },
      menuRetreat() {
        this.menuTransition = 'menu-slide-fade-right';
        this.progressLevel -= this.progressLevel > 1 ? 1 : 0;
        this.activeMenuItems = this.previousMenus[this.previousMenus.length - 1];
        this.previousMenus.pop();
        this.activeMenuTitles.pop();
      },
    },
  };
</script>

<style lang="scss">
  .mobile-navigation__right {
    display: flex;
  }

  .mobile-navigation__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 20px;
    height: $mobile-nav-height;
    transition: 0.3s ease all;
  }

  .mobile-navigation__nav {
    position: fixed;
    top: 0;
    left: 0;
    padding: 0 0 ($spacing-unit * 12);
    width: 100%;
    height: 100vh;
    background-color: $color-orange;
    overflow-y: scroll;
  }

  .mobile-navigation__nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ($spacing-unit * 18);
    padding: ($spacing-unit * 4) ($spacing-unit * 4.5);
  }

  .mobile-navigation__back-button {
    .icon {
      fill: $color-white;
    }
  }

  .mobile-navigation__menu-heading {
    color: $color-white;
    font-size: rem(20px);
    line-height: rem(26px);
    font-weight: 500;
    margin-bottom: 0;
  }

  .mobile-navigation__menu-heading,
  .mobile-navigation__close-button {
    margin-left: auto;
  }

  .mobile-navigation__close-button {
    .icon {
      fill: $color-white;
    }
  }

  .mobile-navigation__linklist {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    flex-direction: column;
  }

  .mobile-navigation__node {
    display: flex;
    align-items: center;
    padding: 0 ($spacing-unit * 4) ($spacing-unit * 4);
    line-height: 1.375;
  }

  .mobile-navigation__node-icon {
    .icon {
      fill: $color-white;
    }
  }

  .mobile-navigation__link {
    margin-right: 20px;
    color: $color-white;
    font-size: rem(22);
    line-height: rem(31);
    font-weight: 500;
    text-decoration: none;
  }

  .mobile-navigation__footer {
    display: none;
    padding: $spacing-unit * 4;
  }

  .mobile-navigation__account-link,
  .mobile-navigation__footer-link {
    display: block;
    color: $color-black;
    margin-bottom: ($spacing-unit * 3);
    font-size: rem(17);
    line-height: rem(22);
    text-decoration: underline;

    svg,
    span {
      margin-right: $spacing-unit * 2;
      vertical-align: middle;
    }
  }

  .mobile-navigation__contact-info {
    font-size: rem(15);
    line-height: rem(19);
  }

  .mobile-navigation__divider {
    margin: 0 ($spacing-unit * 4.5);
    border: 0;
    border-top: 1px solid $color-primary-400;
  }
</style>
